export default "__VITE_ASSET__DEdxtb5W__"